import '@/assets/css/index.scss'

export default function initCSS(): string {
  return 'done'
}
